webpackJsonp([0],{

/***/ "./components/Navbar/Item.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Item;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _theme = __webpack_require__("./theme.js");
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function Item(_ref) {
		var title = _ref.title,
		    url = _ref.url;
	
		return Glamor.createElement(
			'li',
			{ css: styles.item, key: url },
			Glamor.createElement(
				_gatsbyLink2.default,
				{
					onlyActiveOnIndex: true,
					css: styles.link,
					activeStyle: styles.link__active,
					to: url
				},
				title
			)
		);
	};
	
	Item.propTypes = {
		title: _react.PropTypes.string.isRequired,
		url: _react.PropTypes.string.isRequired
	};
	
	/* eslint quote-props: ["error", "as-needed"] */
	var styles = {
		// item
		item: {
			fontWeight: 300,
			margin: '0 0 2px',
			marginLeft: '20px'
		},
		link: _defineProperty({
			borderBottomRightRadius: 3,
			borderTopRightRadius: 3,
			color: 'white',
			display: 'block',
			padding: '0.5em 1rem',
			textDecoration: 'none',
			transition: 'opacity 100ms',
	
			':hover': {
				backgroundColor: 'rgba(255, 255, 255, 0.1)'
			}
		}, _theme2.default.breakpoint.largeUp, {
			paddingLeft: '2rem',
			paddingRight: '2rem'
		}),
		link__active: {
			backgroundColor: _theme2.default.color.blue,
			opacity: 1
		}
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ },

/***/ "./components/Navbar/Menu.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _section;
	
	exports.default = Menu;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__("./theme.js");
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _utils = __webpack_require__("./components/Navbar/utils/index.js");
	
	var _Item = __webpack_require__("./components/Navbar/Item.js");
	
	var _Item2 = _interopRequireDefault(_Item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var welcome = {
		section: 'Welcome',
		slug: '/introduction/getting-started'
	};
	var guides = {
		section: 'Guides',
		slug: '/guides',
		items: [{
			label: 'Keystone Yeoman Generator',
			slug: '/yo-generator'
		}, {
			label: 'Upgrade Guide: 0.3 to 4.0',
			slug: '/v-0-3-to-v-4-0-upgrade-guide'
		}, {
			section: 'Setting Up',
			slug: '/setting-up',
			items: [{
				label: 'Part 1: Initial Setup',
				slug: '/part-1'
			}, {
				label: 'Part 2 - Database Setup',
				slug: '/part-2'
			}, {
				label: 'Part 3: Routing',
				slug: '/part-3'
			}, {
				label: 'Part 4 -  Adding data to the database from a form',
				slug: '/part-4'
			}]
		}, {
			label: 'API File and Image Uploads',
			slug: '/api-file-image-uploads'
		}, {
			label: 'How to create a blog with Keystone',
			slug: '/how-to-create-a-blog-with-keystone'
		}, {
			label: 'How to send emails with Keystone',
			slug: '/how-to-send-emails'
		}]
	};
	var documentation = {
		section: 'Documentation',
		slug: '/documentation',
		items: [{
			label: 'Configuration',
			slug: '/configuration'
		}, {
			section: 'Database Options',
			slug: '/database',
			items: [{
				label: 'Relationships',
				slug: '/relationships'
			}]
		}, {
			section: 'List',
			slug: '/list',
			items: [{
				label: 'Add',
				slug: '/add'
			}, {
				label: 'Model',
				slug: '/model'
			}, {
				label: 'List Construction Options',
				slug: '/options'
			}, {
				label: 'Register',
				slug: '/register'
			}, {
				label: 'Schema',
				slug: '/schema'
			}, {
				label: 'Update Item',
				slug: '/update-item'
			}]
		}, {
			section: 'Methods',
			slug: '/methods',
			items: [{
				label: 'Close Database connection',
				slug: '/close-database-connection'
			}, {
				label: 'Create Items',
				slug: '/create-items'
			}, {
				label: 'Create Router',
				slug: '/create-router'
			}, {
				label: 'Get',
				slug: '/get'
			}, {
				label: 'Import',
				slug: '/import'
			}, {
				label: 'Importer',
				slug: '/importer'
			}, {
				label: 'Init',
				slug: '/init'
			}, {
				label: 'list',
				slug: '/list'
			}, {
				label: 'Middleware',
				slug: '/middleware'
			}, {
				label: 'Open Database Connection',
				slug: '/open-database-connection'
			}, {
				label: 'Paginate',
				slug: '/paginate'
			}, {
				label: 'Pre',
				slug: '/pre'
			}, {
				label: 'Set',
				slug: '/set'
			}, {
				label: 'Start',
				slug: '/start'
			}, {
				label: 'Update Handler',
				slug: '/update-handler'
			}]
		}, {
			section: 'View',
			slug: '/view',
			items: [{
				label: 'on',
				slug: '/on'
			}, {
				label: 'query',
				slug: '/query'
			}, {
				label: 'render',
				slug: '/render'
			}]
		}, {
			section: 'Field Types',
			items: [{
				label: 'Field Options',
				slug: '/options'
			}, {
				label: 'AzureFile Field',
				slug: '/azurefile'
			}, {
				label: 'Embedly Field',
				slug: '/embedly'
			}, {
				label: 'File Field',
				slug: '/file'
			}, {
				label: 'LocalFile Field',
				slug: '/localfile'
			}, {
				label: 'Local Files',
				slug: '/localfiles'
			}, {
				label: 'S3 File Field',
				slug: '/s-3-file'
			}, {
				label: 'Boolean Field',
				slug: '/boolean'
			}, {
				label: 'CloudinaryImage Field',
				slug: '/cloudinaryimage'
			}, {
				label: 'CloudinaryImages Field',
				slug: '/cloudinaryimages'
			}, {
				label: 'Code Field',
				slug: '/code'
			}, {
				label: 'Date Field',
				slug: '/date'
			}, {
				label: 'Color Field',
				slug: '/color'
			}, {
				label: 'Datearray field',
				slug: '/datearray'
			}, {
				label: 'DateTime Field',
				slug: '/datetime'
			}, {
				label: 'Email Field',
				slug: '/email'
			}, {
				label: 'GeoPoint Field',
				slug: '/geopoint'
			}, {
				label: 'HTML Field',
				slug: '/html'
			}, {
				label: 'Key Field',
				slug: '/key'
			}, {
				label: 'Location Field',
				slug: '/location'
			}, {
				label: 'Markdown Field',
				slug: '/markdown'
			}, {
				label: 'Money Field',
				slug: '/money'
			}, {
				label: 'Name Field',
				slug: '/name'
			}, {
				label: 'Number Field',
				slug: '/number'
			}, {
				label: 'NumberArray field',
				slug: '/numberarray'
			}, {
				label: 'Password Field',
				slug: '/password'
			}, {
				label: 'Relationship Field',
				slug: '/relationship'
			}, {
				label: 'Select Field',
				slug: '/select'
			}, {
				label: 'Text Field',
				slug: '/text'
			}, {
				label: 'Textarea Field',
				slug: '/textarea'
			}, {
				label: 'Textarray Field',
				slug: '/textarray'
			}, {
				label: 'URL Field',
				slug: '/url'
			}]
		}]
	};
	
	var menu = [welcome, guides, documentation];
	
	function makeSection(currentPath, layer, level) {
		return layer.map(function (section, idx) {
			var styleChoice = level === 1 ? styles.section : styles.subsection;
	
			return Glamor.createElement(
				'ul',
				{ key: idx, css: styles['menu' + level] },
				Glamor.createElement(
					'li',
					{ css: styleChoice },
					Glamor.createElement(
						_gatsbyLink2.default,
						{ to: section.slug, css: { textDecoration: 'none', color: 'white' } },
						section.section
					)
				),
				section.items ? section.items.map(function (item) {
					var newPath = currentPath + section.slug;
					if (item.items) {
						return makeSection(newPath, [item], level + 1);
					}
					return Glamor.createElement(_Item2.default, {
						key: item.slug,
						title: item.label,
						url: newPath + item.slug
					});
				}) : null
			);
		});
	}
	
	function Menu(_ref) {
		var items = _ref.items;
	
		var list = makeSection('', menu, 1);
	
		return Glamor.createElement(
			'nav',
			null,
			list
		);
	};
	
	Menu.propTypes = {
		items: _utils.itemsShape.isRequired
	};
	
	/* eslint quote-props: ["error", "as-needed"] */
	var styles = {
		menu1: {
			listStyle: 'none',
			margin: 0,
			paddingRight: '1em'
		},
		menu2: {
			listStyle: 'none',
			marginTop: 0,
			marginBottom: 0,
			marginLeft: '20px',
			paddingRight: '1em'
		},
		section: (_section = {
			fontSize: '1.5em',
			marginTop: '1.8em',
			opacity: 0.6,
			padding: '0 1rem',
			textTransform: 'uppercase'
		}, _defineProperty(_section, _theme2.default.breakpoint.largeUp, {
			paddingLeft: '2rem',
			paddingRight: '2rem'
		}), _defineProperty(_section, ':hover', {
			backgroundColor: 'rgba(255, 255, 255, 0.1)'
		}), _section),
		subsection: {
			fontSize: '1.3em',
			opacity: 0.6,
			padding: '0 1rem',
			marginLeft: '20px',
			textTransform: 'uppercase',
			':hover': {
				backgroundColor: 'rgba(255, 255, 255, 0.1)'
			}
		}
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ },

/***/ "./components/Navbar/index.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _navbar;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _menu2 = __webpack_require__("./node_modules/react-icons/lib/md/menu.js");
	
	var _menu3 = _interopRequireDefault(_menu2);
	
	var _close = __webpack_require__("./node_modules/react-icons/lib/md/close.js");
	
	var _close2 = _interopRequireDefault(_close);
	
	var _linkExternal = __webpack_require__("./node_modules/react-icons/lib/go/link-external.js");
	
	var _linkExternal2 = _interopRequireDefault(_linkExternal);
	
	var _markGithub = __webpack_require__("./node_modules/react-icons/lib/go/mark-github.js");
	
	var _markGithub2 = _interopRequireDefault(_markGithub);
	
	var _socialTwitter = __webpack_require__("./node_modules/react-icons/lib/ti/social-twitter.js");
	
	var _socialTwitter2 = _interopRequireDefault(_socialTwitter);
	
	var _typography = __webpack_require__("./utils/typography.js");
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _logoInverted = __webpack_require__("./images/logo-inverted.svg");
	
	var _logoInverted2 = _interopRequireDefault(_logoInverted);
	
	var _theme = __webpack_require__("./theme.js");
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _utils = __webpack_require__("./components/Navbar/utils/index.js");
	
	var _Menu = __webpack_require__("./components/Navbar/Menu.js");
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navbar = function (_Component) {
		_inherits(Navbar, _Component);
	
		function Navbar(props) {
			_classCallCheck(this, Navbar);
	
			var _this = _possibleConstructorReturn(this, (Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call(this, props));
	
			_this.toggleNavMenu = _this.toggleNavMenu.bind(_this);
	
			_this.state = { menuIsOpen: false };
			return _this;
		}
	
		_createClass(Navbar, [{
			key: 'toggleNavMenu',
			value: function toggleNavMenu(menuIsOpen) {
				this.setState({ menuIsOpen: menuIsOpen });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var menuIsOpen = this.state.menuIsOpen;
	
	
				return Glamor.createElement(
					'aside',
					{ css: styles.navbar },
					Glamor.createElement(
						'div',
						{ css: styles.header },
						Glamor.createElement(
							_gatsbyLink2.default,
							{ to: '/', css: styles.headerBrand },
							Glamor.createElement('img', {
								src: _logoInverted2.default,
								css: styles.headerBrandIcon
							})
						),
						Glamor.createElement(
							'div',
							{ css: styles.header__links },
							Glamor.createElement(
								'a',
								{ href: 'http://demo.keystonejs.com', target: '_blank', css: styles.header__link },
								Glamor.createElement(_linkExternal2.default, { css: styles.header__linkIcon }),
								'Demo'
							),
							Glamor.createElement(
								'a',
								{ href: 'https://github.com/keystonejs/keystone', target: '_blank', css: styles.header__link },
								Glamor.createElement(_markGithub2.default, { css: styles.header__linkIcon }),
								'GitHub'
							)
						),
						Glamor.createElement(
							'button',
							{ onClick: function onClick() {
									return _this2.toggleNavMenu(!menuIsOpen);
								}, css: styles.menuButton },
							menuIsOpen ? Glamor.createElement(_close2.default, { css: styles.menuIcon }) : Glamor.createElement(_menu3.default, { css: styles.menuIcon })
						)
					),
					Glamor.createElement(
						'div',
						{ css: [styles.menu, menuIsOpen && styles.menu__open] },
						Glamor.createElement(_Menu2.default, { items: this.props.items })
					),
					Glamor.createElement(
						'a',
						{ href: 'https://twitter.com/keystonejs', target: '_blank', css: styles.twitter },
						Glamor.createElement(_socialTwitter2.default, { css: styles.twitterIcon }),
						'Twitter'
					)
				);
			}
		}]);
	
		return Navbar;
	}(_react.Component);
	
	;
	
	Navbar.propTypes = {
		closeNavigation: _react.PropTypes.func.isRequired,
		items: _utils.itemsShape.isRequired,
		menuIsOpen: _react.PropTypes.bool.isRequired,
		openNavigation: _react.PropTypes.func.isRequired
	};
	
	var mobileHeaderHeight = 60;
	
	/* eslint quote-props: ["error", "as-needed"] */
	var styles = {
		navbar: (_navbar = {
			backgroundColor: _theme2.default.color.blueDark,
			color: 'white',
			fontSize: '0.9em',
			letterSpacing: '0.01em',
			lineHeight: _typography2.default.options.baseLineHeight,
			width: '100%'
	
		}, _defineProperty(_navbar, _theme2.default.breakpoint.largeUp, {
			bottom: 0,
			height: '100%',
			left: 0,
			overflowY: 'auto',
			position: 'fixed',
			top: 0,
			width: _theme2.default.navbar.widthSmall
		}), _defineProperty(_navbar, _theme2.default.breakpoint.xlargeUp, {
			width: _theme2.default.navbar.widthLarge
		}), _navbar),
	
		// mobile
		menu: _defineProperty({}, _theme2.default.breakpoint.mediumDown, {
			backgroundColor: _theme2.default.color.blueDark,
			display: 'none',
			position: 'absolute',
			top: mobileHeaderHeight,
			width: '100%'
		}),
		menu__open: _defineProperty({}, _theme2.default.breakpoint.mediumDown, {
			display: 'block'
		}),
		menuButton: _defineProperty({
			background: 'none',
			border: 0,
			color: 'white',
			display: 'none',
			fontSize: 32,
			lineHeight: 0,
			outline: 0,
			padding: 0
	
		}, _theme2.default.breakpoint.mediumDown, {
			display: 'inline-block'
		}),
		menuIcon: {},
	
		// header
		header: _defineProperty({}, _theme2.default.breakpoint.mediumDown, {
			alignItems: 'center',
			borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
			display: 'flex',
			height: mobileHeaderHeight,
			justifyContent: 'space-between',
			paddingLeft: '1em',
			paddingRight: '1em'
		}),
		headerBrand: _defineProperty({
			display: 'block',
			lineHeight: 0,
			textAlign: 'center',
			textDecoration: 'none'
	
		}, _theme2.default.breakpoint.largeUp, {
			padding: '2em 0'
		}),
		headerBrandIcon: _defineProperty({
			height: 60,
			margin: 0
	
		}, _theme2.default.breakpoint.mediumDown, {
			height: 30
		}),
	
		header__links: {
			display: 'flex'
		},
		header__linkIcon: {
			marginRight: '0.5em'
		},
		header__link: _defineProperty({
			alignItems: 'center',
			color: 'white',
			display: 'flex',
			flex: 1,
			height: '44px',
			justifyContent: 'center',
			lineHeight: '44px',
			opacity: 0.9,
			padding: '0 1em',
			textAlign: 'center',
			textDecoration: 'none',
	
			':hover': {
				opacity: 1
			},
	
			':first-child': {
				marginRight: 1
			}
	
		}, _theme2.default.breakpoint.largeUp, {
			backgroundColor: 'rgba(0, 0, 0, 0.3)'
		}),
	
		menu__active: {},
	
		// twitter
		twitter: _defineProperty({
			alignItems: 'center',
			backgroundColor: _theme2.default.color.twitter,
			color: 'white',
			display: 'flex',
			fontSize: '1.2em',
			marginTop: '2em',
			justifyContent: 'center',
			padding: '0.75em 1em',
			textDecoration: 'none'
	
		}, _theme2.default.breakpoint.mediumDown, {
			display: 'none'
		}),
		twitterIcon: {
			fontSize: 24,
			marginRight: '0.5em'
		}
	};
	
	exports.default = Navbar;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ },

/***/ "./components/Navbar/utils/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.itemsShape = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var itemsShape = exports.itemsShape = _react.PropTypes.arrayOf(_react.PropTypes.shape({
		section: _react.PropTypes.string,
		items: _react.PropTypes.arrayOf(_react.PropTypes.shape({
			label: _react.PropTypes.string,
			slug: _react.PropTypes.string
		}))
	}));

/***/ },

/***/ "./css/prism-coy.css":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ":not(pre)>code[class*=language-],pre[class*=language-]{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;margin-bottom:1em}:not(pre)>code[class*=language-]{position:relative;padding:.2em;border-radius:.3em;color:#c92c2c;border:1px solid rgba(0,0,0,.1);display:inline;white-space:normal}pre[class*=language-]:after,pre[class*=language-]:before{content:\"\";z-index:-2;display:block;position:absolute;bottom:.75em;left:.18em;width:40%;height:20%;max-height:13em;box-shadow:0 13px 8px #979797;-webkit-transform:rotate(-2deg);-moz-transform:rotate(-2deg);-ms-transform:rotate(-2deg);-o-transform:rotate(-2deg);transform:rotate(-2deg)}:not(pre)>code[class*=language-]:after,pre[class*=language-]:after{right:.75em;left:auto;-webkit-transform:rotate(2deg);-moz-transform:rotate(2deg);-ms-transform:rotate(2deg);-o-transform:rotate(2deg);transform:rotate(2deg)}.token.block-comment,.token.cdata,.token.comment,.token.doctype,.token.prolog{color:#7d8b99}.token.punctuation{color:#5f6364}.token.boolean,.token.constant,.token.deleted,.token.function-name,.token.number,.token.property,.token.symbol,.token.tag{color:#c92c2c}.token.attr-name,.token.builtin,.token.char,.token.function,.token.inserted,.token.selector,.token.string{color:#2f9c0a}.token.entity,.token.operator,.token.url,.token.variable{color:#a67f59}.token.atrule,.token.attr-value,.token.class-name,.token.keyword{color:#1990b8}.token.important,.token.regex{color:#e90}.language-css .token.string,.style .token.string{color:#a67f59}.token.important{font-weight:400}.token.bold{font-weight:700}.token.italic{font-style:italic}.token.entity{cursor:help}.namespace{opacity:.7}@media screen and (max-width:767px){pre[class*=language-]:after,pre[class*=language-]:before{bottom:14px;box-shadow:none}}.token.cr:before,.token.lf:before,.token.tab:not(:empty):before{color:#e0d7d1}pre[class*=language-].line-numbers{padding-left:0}pre[class*=language-].line-numbers code{padding-left:3.8em}pre[class*=language-].line-numbers .line-numbers-rows{left:0}pre[class*=language-][data-line]{padding-top:0;padding-bottom:0;padding-left:0}pre[data-line] code{position:relative;padding-left:4em}pre .line-highlight{margin-top:0}", ""]);
	
	// exports


/***/ },

/***/ "./css/styles.css":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "body{font-size:13px;line-height:1.4}[data-primitive-type]:after,code{border-radius:2px;opacity:.8;padding:0 4px 1px;border-right:3px solid #fff}h4>code{background-color:#ffb6c1}[data-primitive-type]:after{background-color:#87cefa;content:attr(data-primitive-type);font-family:monospace}", ""]);
	
	// exports


/***/ },

/***/ "./images/logo-inverted.svg":
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMTAwIDEwMS40IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxMDAgMTAxLjQiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPGc+DQoJCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik05NS42LDBINC40QzIsMCwwLDIsMCw0LjV2OTIuNWMwLDIuNSwyLDQuNSw0LjQsNC41aDkxLjJjMi40LDAsNC40LTIsNC40LTQuNVY0LjVDMTAwLDIsOTgsMCw5NS42LDB6DQoJCQkgTTYzLjgsODYuOEw0Mi40LDU3LjhsLTUuNSw2Ljd2MjIuM0gyMi4zdi03MmgxNC41djMyLjJsMjUtMzIuMmgxOC41TDUyLjMsNDguNWwzMCwzOC4zSDYzLjh6Ii8+DQoJPC9nPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo="

/***/ },

/***/ "./node_modules/css-loader/lib/css-base.js":
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },

/***/ "./node_modules/exenv/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },

/***/ "./node_modules/lodash._getnative/index.js":
/***/ function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ },

/***/ "./node_modules/lodash.isarguments/index.js":
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ },

/***/ "./node_modules/lodash.isarray/index.js":
/***/ function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ },

/***/ "./node_modules/lodash.keys/index.js":
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__("./node_modules/lodash._getnative/index.js"),
	    isArguments = __webpack_require__("./node_modules/lodash.isarguments/index.js"),
	    isArray = __webpack_require__("./node_modules/lodash.isarray/index.js");
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },

/***/ "./node_modules/react-document-title/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__("./node_modules/react/react.js"),
	    withSideEffect = __webpack_require__("./node_modules/react-side-effect/lib/index.js");
	
	function reducePropsToState(propsList) {
	  var innermostProps = propsList[propsList.length - 1];
	  if (innermostProps) {
	    return innermostProps.title;
	  }
	}
	
	function handleStateChangeOnClient(title) {
	  var nextTitle = title || '';
	  if (nextTitle !== document.title) {
	    document.title = nextTitle;
	  }
	}
	
	var DocumentTitle = React.createClass({
	  displayName: 'DocumentTitle',
	
	  propTypes: {
	    title: React.PropTypes.string.isRequired
	  },
	
	  render: function render() {
	    if (this.props.children) {
	      return React.Children.only(this.props.children);
	    } else {
	      return null;
	    }
	  }
	});
	
	module.exports = withSideEffect(
	  reducePropsToState,
	  handleStateChangeOnClient
	)(DocumentTitle);


/***/ },

/***/ "./node_modules/react-icon-base/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconBase = function IconBase(_ref, _ref2) {
	  var children = _ref.children;
	  var color = _ref.color;
	  var size = _ref.size;
	  var style = _ref.style;
	
	  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style']);
	
	  var _ref2$reactIconBase = _ref2.reactIconBase;
	  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;
	
	  var computedSize = size || reactIconBase.size || '1em';
	  return _react2.default.createElement('svg', _extends({
	    children: children,
	    fill: 'currentColor',
	    preserveAspectRatio: 'xMidYMid meet',
	    height: computedSize,
	    width: computedSize
	  }, reactIconBase, props, {
	    style: _extends({
	      verticalAlign: 'middle',
	      color: color || reactIconBase.color
	    }, reactIconBase.style || {}, style)
	  }));
	};
	
	IconBase.propTypes = {
	  color: _react.PropTypes.string,
	  size: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  style: _react.PropTypes.object
	};
	
	IconBase.contextTypes = {
	  reactIconBase: _react.PropTypes.shape(IconBase.propTypes)
	};
	
	exports.default = IconBase;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-icons/lib/go/link-external.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoLinkExternal = function GoLinkExternal(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30 30h-20v-19.9l5-0.1v-5h-10v30h30v-12.5h-5v7.5z m-10-25l5 5-7.5 7.5 5 5 7.5-7.5 5 5v-15h-15z' })
	        )
	    );
	};
	
	exports.default = GoLinkExternal;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-icons/lib/go/mark-github.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoMarkGithub = function GoMarkGithub(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20 0c-11 0-20 9-20 20 0 8.8 5.7 16.3 13.7 19 1 0.2 1.3-0.5 1.3-1 0-0.5 0-2 0-3.7-5.5 1.2-6.7-2.4-6.7-2.4-0.9-2.3-2.2-2.9-2.2-2.9-1.9-1.2 0.1-1.2 0.1-1.2 2 0.1 3.1 2.1 3.1 2.1 1.7 3 4.6 2.1 5.8 1.6 0.2-1.3 0.7-2.2 1.3-2.7-4.5-0.5-9.2-2.2-9.2-9.8 0-2.2 0.8-4 2.1-5.4-0.2-0.5-0.9-2.6 0.2-5.3 0 0 1.7-0.5 5.5 2 1.6-0.4 3.3-0.6 5-0.6 1.7 0 3.4 0.2 5 0.7 3.8-2.6 5.5-2.1 5.5-2.1 1.1 2.8 0.4 4.8 0.2 5.3 1.3 1.4 2.1 3.2 2.1 5.4 0 7.6-4.7 9.3-9.2 9.8 0.7 0.6 1.4 1.9 1.4 3.7 0 2.7 0 4.9 0 5.5 0 0.6 0.3 1.2 1.3 1 8-2.7 13.7-10.2 13.7-19 0-11-9-20-20-20z' })
	        )
	    );
	};
	
	exports.default = GoMarkGithub;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-icons/lib/go/pencil.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoPencil = function GoPencil(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30 2.5l-5 5 7.5 7.5 5-5-7.5-7.5z m-27.5 27.5l0 7.5 7.5 0 20-20-7.5-7.5-20 20z m7.5 5h-5v-5h2.5v2.5h2.5v2.5z' })
	        )
	    );
	};
	
	exports.default = GoPencil;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-icons/lib/md/close.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdClose = function MdClose(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 10.7l-9.3 9.3 9.3 9.3-2.3 2.3-9.3-9.3-9.3 9.3-2.3-2.3 9.3-9.3-9.3-9.3 2.3-2.3 9.3 9.3 9.3-9.3z' })
	        )
	    );
	};
	
	exports.default = MdClose;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-icons/lib/md/menu.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdMenu = function MdMenu(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm5 10h30v3.4h-30v-3.4z m0 11.6v-3.2h30v3.2h-30z m0 8.4v-3.4h30v3.4h-30z' })
	        )
	    );
	};
	
	exports.default = MdMenu;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-icons/lib/ti/social-twitter.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TiSocialTwitter = function TiSocialTwitter(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.5 11.7c1.3-0.8 2.2-2 2.7-3.4-1.4 0.7-2.7 1.2-4 1.4-1.1-1.2-2.6-1.9-4.4-1.9-1.7 0-3.2 0.6-4.4 1.8-1.2 1.2-1.8 2.7-1.8 4.4 0 0.5 0.1 0.9 0.2 1.3-5.1-0.1-9.4-2.3-12.7-6.4-0.6 1-0.9 2.1-0.9 3.1 0 2.2 1 3.9 2.8 5.2-1.1-0.1-2-0.4-2.8-0.8 0 1.5 0.5 2.8 1.4 4 0.9 1.1 2.1 1.8 3.5 2.1-0.5 0.1-1 0.2-1.6 0.2-0.5 0-0.9 0-1.1-0.1 0.4 1.2 1.1 2.3 2.1 3 1.1 0.8 2.3 1.2 3.6 1.3-2.2 1.7-4.7 2.6-7.6 2.6-0.7 0-1.2 0-1.5-0.1 2.8 1.9 6 2.8 9.5 2.8 3.5 0 6.7-0.9 9.4-2.7 2.8-1.8 4.8-4.1 6.1-6.7 1.3-2.6 1.9-5.3 1.9-8.1v-0.8c1.3-0.9 2.3-2 3.1-3.2-1.1 0.5-2.3 0.8-3.5 1z' })
	        )
	    );
	};
	
	exports.default = TiSocialTwitter;
	module.exports = exports['default'];

/***/ },

/***/ "./node_modules/react-side-effect/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__("./node_modules/exenv/index.js");
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__("./node_modules/shallowequal/modules/index.js");
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = undefined;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = (function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        _Component.apply(this, arguments);
	      }
	
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !_shallowequal2['default'](nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2['default'].createElement(WrappedComponent, this.props);
	      };
	
	      _createClass(SideEffect, null, [{
	        key: 'displayName',
	
	        // Try to use displayName of wrapped component
	        value: 'SideEffect(' + getDisplayName(WrappedComponent) + ')',
	
	        // Expose canUseDOM so tests can monkeypatch it
	        enumerable: true
	      }, {
	        key: 'canUseDOM',
	        value: _exenv2['default'].canUseDOM,
	        enumerable: true
	      }]);
	
	      return SideEffect;
	    })(_react.Component);
	
	    return SideEffect;
	  };
	};

/***/ },

/***/ "./node_modules/shallowequal/modules/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var fetchKeys = __webpack_require__("./node_modules/lodash.keys/index.js");
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if (ret !== void 0) {
	        return !!ret;
	    }
	
	    if (objA === objB) {
	        return true;
	    }
	
	    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = fetchKeys(objA);
	    var keysB = fetchKeys(objB);
	
	    var len = keysA.length;
	    if (len !== keysB.length) {
	        return false;
	    }
	
	    compareContext = compareContext || null;
	
	    // Test for A's keys different from B.
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	    for (var i = 0; i < len; i++) {
	        var key = keysA[i];
	        if (!bHasOwnProperty(key)) {
	            return false;
	        }
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	        if (_ret === false || _ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	    }
	
	    return true;
	};

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-100.eot":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-100.e2085b49.eot";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-100.svg":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-100.3b8bb203.svg";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-100.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-100.654cb4d3.woff";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-100.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-100.8ce59883.woff2";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-100italic.eot":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-100italic.fafacae6.eot";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-100italic.svg":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-100italic.4bec22c5.svg";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-100italic.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-100italic.42de8983.woff";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-100italic.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-100italic.acee0ea9.woff2";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-300.eot":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-300.c3547b2e.eot";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-300.svg":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-300.1edaa6e5.svg";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-300.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-300.ecce92d0.woff";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-300.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-300.16ddb154.woff2";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-300italic.eot":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-300italic.2f1aacc1.eot";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-300italic.svg":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-300italic.290e6a6c.svg";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-300italic.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-300italic.4d08daeb.woff";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-300italic.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-300italic.3ddb7482.woff2";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-400.eot":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-400.9f916e33.eot";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-400.svg":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-400.3d3a5358.svg";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-400.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-400.16e1d930.woff";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-400.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-400.7e367be0.woff2";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-400italic.eot":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-400italic.16a42151.eot";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-400italic.svg":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-400italic.13fb9544.svg";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-400italic.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-400italic.1e65e7e4.woff";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-400italic.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-400italic.984ae378.woff2";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-500.eot":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-500.2a52a20f.eot";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-500.svg":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-500.f1d811cd.svg";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-500.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-500.57af64fc.woff";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-500.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-500.bb474f16.woff2";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-500italic.eot":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-500italic.e50328c0.eot";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-500italic.svg":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-500italic.084d5c43.svg";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-500italic.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-500italic.b670694b.woff";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-500italic.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-500italic.9e7beee5.woff2";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-700.eot":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-700.128879da.eot";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-700.svg":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-700.7f57c4c0.svg";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-700.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-700.525d5b45.woff";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-700.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-700.0d7e71f2.woff2";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-700italic.eot":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-700italic.96166ad6.eot";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-700italic.svg":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-700italic.bf39ef96.svg";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-700italic.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-700italic.ad0e74fc.woff";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-700italic.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-700italic.7394ca9f.woff2";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-900.eot":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-900.355550fa.eot";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-900.svg":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-900.e43f0ef2.svg";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-900.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-900.de984c02.woff";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-900.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-900.f4e8dc59.woff2";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-900italic.eot":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-900italic.822eba9c.eot";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-900italic.svg":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-900italic.258ac030.svg";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-900italic.woff":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-900italic.3b9590e0.woff";

/***/ },

/***/ "./node_modules/typeface-roboto/files/roboto-latin-900italic.woff2":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roboto-latin-900italic.4faec832.woff2";

/***/ },

/***/ "./node_modules/typeface-roboto/index.css":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:Roboto;font-style:italic;font-weight:100;src:url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-100italic.eot") + ");src:local(\"Roboto Thin italic\"),local(\"Roboto-Thinitalic\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-100italic.eot") + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-100italic.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-100italic.woff") + ") format(\"woff\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-100italic.svg") + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:normal;font-weight:300;src:url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-300.eot") + ");src:local(\"Roboto Light \"),local(\"Roboto-Light\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-300.eot") + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-300.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-300.woff") + ") format(\"woff\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-300.svg") + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:italic;font-weight:300;src:url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-300italic.eot") + ");src:local(\"Roboto Light italic\"),local(\"Roboto-Lightitalic\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-300italic.eot") + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-300italic.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-300italic.woff") + ") format(\"woff\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-300italic.svg") + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:normal;font-weight:400;src:url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-400.eot") + ");src:local(\"Roboto Regular \"),local(\"Roboto-Regular\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-400.eot") + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-400.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-400.woff") + ") format(\"woff\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-400.svg") + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:italic;font-weight:400;src:url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-400italic.eot") + ");src:local(\"Roboto Regular italic\"),local(\"Roboto-Regularitalic\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-400italic.eot") + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-400italic.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-400italic.woff") + ") format(\"woff\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-400italic.svg") + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:normal;font-weight:500;src:url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-500.eot") + ");src:local(\"Roboto Medium \"),local(\"Roboto-Medium\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-500.eot") + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-500.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-500.woff") + ") format(\"woff\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-500.svg") + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:italic;font-weight:500;src:url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-500italic.eot") + ");src:local(\"Roboto Medium italic\"),local(\"Roboto-Mediumitalic\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-500italic.eot") + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-500italic.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-500italic.woff") + ") format(\"woff\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-500italic.svg") + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:normal;font-weight:700;src:url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-700.eot") + ");src:local(\"Roboto Bold \"),local(\"Roboto-Bold\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-700.eot") + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-700.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-700.woff") + ") format(\"woff\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-700.svg") + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:italic;font-weight:700;src:url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-700italic.eot") + ");src:local(\"Roboto Bold italic\"),local(\"Roboto-Bolditalic\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-700italic.eot") + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-700italic.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-700italic.woff") + ") format(\"woff\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-700italic.svg") + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:normal;font-weight:900;src:url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-900.eot") + ");src:local(\"Roboto Black \"),local(\"Roboto-Black\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-900.eot") + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-900.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-900.woff") + ") format(\"woff\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-900.svg") + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:italic;font-weight:900;src:url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-900italic.eot") + ");src:local(\"Roboto Black italic\"),local(\"Roboto-Blackitalic\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-900italic.eot") + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-900italic.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-900italic.woff") + ") format(\"woff\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-900italic.svg") + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:normal;font-weight:100;src:url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-100.eot") + ");src:local(\"Roboto Thin \"),local(\"Roboto-Thin\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-100.eot") + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-100.woff2") + ") format(\"woff2\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-100.woff") + ") format(\"woff\"),url(" + __webpack_require__("./node_modules/typeface-roboto/files/roboto-latin-100.svg") + "#roboto) format(\"svg\")}", ""]);
	
	// exports


/***/ },

/***/ "./templates/template-doc-layout.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.pageQuery = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _templateDocPage = __webpack_require__("./templates/template-doc-page.js");
	
	var _templateDocPage2 = _interopRequireDefault(_templateDocPage);
	
	var _Navbar = __webpack_require__("./components/Navbar/index.js");
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__("./css/prism-coy.css");
	__webpack_require__("./css/styles.css");
	__webpack_require__("./node_modules/typeface-roboto/index.css");
	
	var DocumentLayout = function (_React$Component) {
		_inherits(DocumentLayout, _React$Component);
	
		function DocumentLayout(props) {
			_classCallCheck(this, DocumentLayout);
	
			var _this = _possibleConstructorReturn(this, (DocumentLayout.__proto__ || Object.getPrototypeOf(DocumentLayout)).call(this, props));
	
			_this.getNavItems = _this.getNavItems.bind(_this);
			return _this;
		}
	
		_createClass(DocumentLayout, [{
			key: 'getNavItems',
			value: function getNavItems() {
				var edges = this.props.data.allMarkdownRemark.edges;
	
				var currentSection = void 0;
				var sections = {};
	
				edges.forEach(function (_ref) {
					var node = _ref.node;
					var section = node.section;
	
					var newSection = section !== currentSection;
					currentSection = section;
	
					if (newSection) sections[section] = [];
				});
	
				edges.forEach(function (_ref2) {
					var node = _ref2.node;
					var headings = node.headings,
					    section = node.section,
					    slug = node.slug;
	
	
					var label = headings.map(function (h) {
						return h.value;
					})[0] || '(no title)';
	
					sections[section].push({ label: label, slug: slug });
				});
	
				return Object.keys(sections).map(function (s) {
					return {
						section: s || '(no section)',
						items: sections[s]
					};
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    data = _props.data,
				    markdownRemark = _props.data.markdownRemark;
				var siteTitle = data.site.siteMetadata.title;
	
				var body = markdownRemark.html;
				var path = markdownRemark.parent.relativePath;
	
				// TODO sorting should come from graphQL
				// also, `join` is because some pages still have multiple H1s
				var title = markdownRemark.headings.sort(function (a, b) {
					return a.value.localeCompare(b.value);
				}).map(function (h) {
					return h.value;
				}).join(', ');
	
				// TODO add file path to Markdown schema
				// NOTE pointing to `docs` until ready for `master`
				var editPath = '\n\t\t\thttps://github.com/keystonejs/keystone/blob/docs/docs/' + path + '\n\t\t';
	
				// console.log('data', this.props.data);
				// console.log('location', this.props.location);
	
				return Glamor.createElement(
					'div',
					null,
					Glamor.createElement(_Navbar2.default, { items: this.getNavItems() }),
					Glamor.createElement(_templateDocPage2.default, {
						body: body,
						editPath: editPath,
						siteTitle: siteTitle,
						title: title
					})
				);
			}
		}]);
	
		return DocumentLayout;
	}(_react2.default.Component);
	
	exports.default = DocumentLayout;
	;
	
	// TODO only select headings of depth 1
	var pageQuery = exports.pageQuery = '\nquery MarkdownTemplate($slug: String!) {\n\tsite {\n\t\tsiteMetadata {\n\t\t\ttitle\n\t\t}\n\t}\n\tallMarkdownRemark {\n\t\tedges {\n\t\t\tnode {\n\t\t\t\tsection\n\t\t\t\tslug\n\t\t\t\theadings(depth: h1) {\n\t\t\t\t\tvalue\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\tmarkdownRemark(slug: { eq: $slug }) {\n\t\tparent {\n\t\t\t...on File {\n\t\t\t\trelativePath\n\t\t\t}\n\t\t}\n\t\tslug\n\t\theadings(depth: h1) {\n\t\t\tvalue\n\t\t}\n\t\thtml\n\t}\n}\n';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ },

/***/ "./templates/template-doc-page.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _content;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__("./node_modules/react-document-title/index.js");
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _pencil = __webpack_require__("./node_modules/react-icons/lib/go/pencil.js");
	
	var _pencil2 = _interopRequireDefault(_pencil);
	
	var _typography = __webpack_require__("./utils/typography.js");
	
	var _theme = __webpack_require__("./theme.js");
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _Container = __webpack_require__("./components/Container.jsx");
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DocumentPage = function (_Component) {
		_inherits(DocumentPage, _Component);
	
		function DocumentPage() {
			_classCallCheck(this, DocumentPage);
	
			return _possibleConstructorReturn(this, (DocumentPage.__proto__ || Object.getPrototypeOf(DocumentPage)).apply(this, arguments));
		}
	
		_createClass(DocumentPage, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    body = _props.body,
				    editPath = _props.editPath,
				    siteTitle = _props.siteTitle,
				    title = _props.title;
	
	
				return Glamor.createElement(
					_reactDocumentTitle2.default,
					{ title: title + ' | ' + siteTitle },
					Glamor.createElement(
						'div',
						{ css: styles.content },
						Glamor.createElement(
							_Container2.default,
							{ width: 'medium' },
							Glamor.createElement(
								'article',
								{ css: styles.article },
								Glamor.createElement(
									'a',
									{ href: editPath, css: styles.edit, target: '_blank' },
									Glamor.createElement(_pencil2.default, { css: styles.editIcon }),
									'Edit this page'
								),
								Glamor.createElement('div', { dangerouslySetInnerHTML: { __html: body } })
							)
						)
					)
				);
			}
		}]);
	
		return DocumentPage;
	}(_react.Component);
	
	/* eslint quote-props: ["error", "as-needed"] */
	
	
	var styles = {
		content: (_content = {}, _defineProperty(_content, _theme2.default.breakpoint.largeUp, {
			marginLeft: _theme2.default.navbar.widthSmall,
			minHeight: '100vh'
		}), _defineProperty(_content, _theme2.default.breakpoint.xlargeUp, {
			marginLeft: _theme2.default.navbar.widthLarge
		}), _content),
		article: _defineProperty({
			paddingBottom: (0, _typography.rhythm)(1),
			paddingTop: (0, _typography.rhythm)(1)
	
		}, _theme2.default.breakpoint.largeUp, {
			paddingBottom: (0, _typography.rhythm)(2),
			paddingTop: (0, _typography.rhythm)(2)
		}),
		edit: {
			color: _theme2.default.color.gray40,
			float: 'right',
			display: 'inline-flex',
			alignItems: 'center',
			fontSize: '0.9em',
			marginTop: (0, _typography.rhythm)(1),
			textDecoration: 'none',
			textTransform: 'uppercase',
			transition: 'color 100ms',
	
			':hover': {
				color: _theme2.default.color.gray60
			}
		},
		editIcon: {
			marginRight: '0.5em'
		}
	};
	
	exports.default = DocumentPage;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ }

});


// WEBPACK FOOTER //
// page-component---templates-template-doc-layout-js-51176fc9ede55993b413.js